import {
	List,
	Datagrid,
	TextField,
	EditButton,
	CreateButton,
	TopToolbar,
	useResourceContext,
	useCanAccess,
	ReferenceField
} from 'react-admin';

const PersonaListActions = () => (
	<TopToolbar>
		<CreateButton />
	</TopToolbar>
);

const PersonaList = (props) => {
		const resource = useResourceContext(props);
		const { canAccess, isPending } = useCanAccess({
			action: 'edit',
			resource
		});

		const rowClick = !canAccess || isPending ? 'show' : 'edit';
		
	return (
		<List
			actions={<PersonaListActions />}
			exporter={false}
		>
			<Datagrid rowClick={rowClick}>
				<TextField source="name" />
				<TextField source="hostname" />
				<TextField source="description" />
				<ReferenceField source="library_id" reference="libraries" />
				<ReferenceField source="voice_id" reference="voices" />
				<EditButton />
			</Datagrid>
		</List>
	);

}

export default PersonaList;
